import React from "react";
import GenericButton from "../../common/genericButton";
import GenericInput from "../../common/GenericInput";
import GenericModal from "../../common/genericModal";
import styles from "./Forgot.module.scss";
import { Link } from "react-router-dom";

const Forgot = ({ isOpen, toggle }) => {
  const changeHandler = () => {};
  return (
    <>
      <GenericModal isOpen={isOpen} toggle={toggle}>
        <div className={styles.mainheading}>Forgot Passowrd</div>
        <GenericInput
          placeholder="Enter your email "
          type="text"
          withRightIcon={false}
          name="email"
          icon={"/assets/icons-email.svg"}
          onChange={changeHandler}
        />
        <div className={styles.text}>
          <Link to="">
            <a>
              <p>
                Not Recieved? <span>Resend</span>
              </p>
            </a>
          </Link>
        </div>
        <GenericButton title={"Send"} />
      </GenericModal>
    </>
  );
};

export default Forgot;
